import {
    Collection,
    BaseCollections
} from './base';

Collection.Client = class Client extends Collection.Base {

    checkItem(item) {
        return super.checkItem(...arguments);
    }
};

const ClientCollections = new BaseCollections();


export {
    ClientCollections
}

